import { render, staticRenderFns } from "./PNav.vue?vue&type=template&id=79b43ee7&"
import script from "./PNav.vue?vue&type=script&lang=js&"
export * from "./PNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports